import React from "react";
import styled from "@emotion/styled";

const ImprovementSummaryCards = ({ totalQuestions, cards }) => {
  return (
    <CardsRow className="upAuditsCard" style={{flexDirection:"row"}}>
      <TotalCard>
        <TotalLabel>Total Questions</TotalLabel>
        <TotalValue>{totalQuestions}</TotalValue>
      </TotalCard>

      {cards.map((c) => (
        <CycleCard key={c.id} color={c.color}>
          <CycleHeading color={c.color}>
            <Dot color={c.color} />
            {c.name}
          </CycleHeading>
          <CycleDate>{c.date}</CycleDate>
          <LostLabel>Lost Marks</LostLabel>
          <ValueRow>
            <ValueText>
              {c.lostTotal} <Muted>/ {c.possibleTotal}</Muted>
            </ValueText>
            <PercentBadge color={c.color}>
              {c.possibleTotal ? Math.round((c.lostTotal / c.possibleTotal) * 100) : 0}%
            </PercentBadge>
          </ValueRow>
        </CycleCard>
      ))}
    </CardsRow>
  );
};

const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.9rem;
  border: 1px solid #eaecef;
  border-radius: 12px;
  padding: 1rem 1.25rem;
`;

const TotalCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-width: 140px;
`;

const TotalLabel = styled.span`
  font-size: 0.82rem;
  font-weight: 700;
  color: #16325c;
`;

const TotalValue = styled.span`
  font-size: 1.6rem;
  font-weight: 800;
  color: #16325c;
`;

const CycleCard = styled.div`
  flex: 1;
  min-width: 150px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0.6rem 0.9rem;
  border-radius: 10px;
  background: ${(props) => `${props.color}0D`};
`;

const CycleHeading = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  font-weight: 700;
  color: ${(props) => props.color};
`;

const CycleDate = styled.span`
  font-size: 0.72rem;
  color: #8a94a6;
  margin-left: 15px;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.color};
  flex-shrink: 0;
`;

const LostLabel = styled.span`
  font-size: 0.72rem;
  color: #8a94a6;
  margin-top: 4px;
`;

const ValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
`;

const ValueText = styled.span`
  font-size: 1.15rem;
  font-weight: 800;
  color: #16325c;
`;

const Muted = styled.span`
  font-size: 0.85rem;
  font-weight: 500;
  color: #8a94a6;
`;

const PercentBadge = styled.span`
  font-size: 0.72rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
  background: ${(props) => `${props.color}22`};
  color: ${(props) => props.color};
`;

export default ImprovementSummaryCards;
